import React, { useEffect } from 'react'

import dynamic from 'next/dynamic'

// import logo from '@assets/images/placeholder/footer-logo.svg'
import logo from '@shared-submodule/sm-assets/HikeSports-logo.png'
import facebookIcon from '@assets/images/icon/facebook-icon.png'
import instagramIcon from '@assets/images/icon/instagram-icon.png'
import twitterIcon from '@assets/images/icon/twitter-icon.png'
import youtubeIcon from '@assets/images/icon/youtube-icon.png'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { FACEBOOK_URL, INSTAGRAM_URL, TWITTER_URL, YOUTUBE_URL } from '@shared-submodule/sm-constants'
import googlePlay from '@assets/images/icon/google-play.svg'
import appleStore from '@assets/images/icon/app-store.svg'
import CommonFooter from '@shared-submodule/sm-components/footer'
import { footerConfig } from '@shared/constants/utils'
const MyImage = dynamic(() => import('@shared/components/myImage'))
const CustomLink = dynamic(() => import('../customLink'))

function Footer() {
  const footerTwoData = footerConfig(allRoutes, {
    FACEBOOK_URL,
    INSTAGRAM_URL,
    TWITTER_URL,
    YOUTUBE_URL,
    facebookIcon,
    twitterIcon,
    instagramIcon,
    youtubeIcon,
    googlePlay,
    appleStore,
    logo,
    CustomLink,
    MyImage
  })

  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.innerHTML = `
      _linkedin_partner_id = "7110044";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);

      (function(l) {
        if (!l) {
          window.lintrk = function(a, b) { window.lintrk.q.push([a, b]) };
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    `
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<img height="1" width="1" style="display:none;" alt=""
                          src="https://px.ads.linkedin.com/collect/?pid=7110044&fmt=gif" />`
    document.body.appendChild(noscript)
  }, [])

  return <CommonFooter {...footerTwoData} />
}
export default Footer
